exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsvg[data-v-d483c6fa] {\n  height: 24px;\n  width: 24px;\n}\n#the-footer[data-v-d483c6fa] {\n  z-index: 999;\n}\n", ""]);

// exports
